/**
 * Texto comparable: sin acentos, sin mayúsculas y con cualquier cosa que no sea letra o número
 * convertida en un espacio. Es la misma normalización que usa el Backend para buscar prompts por
 * nombre (`prompt_search.normalize`, contrato §3.1), así que lo que la pantalla encuentra y lo que
 * encuentra la IA se parecen.
 */
export function normalizeText(value) {
    return String(value || '')
        .normalize('NFKD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
}

export function compareText(a, b) {
    const left = normalizeText(a);
    const right = normalizeText(b);
    if (left < right) return -1;
    if (left > right) return 1;
    return 0;
}
